import parser from 'ua-parser-js'
import AppState from '@/plugins/appstate'
import Logger from '@/plugins/logger'
import {CreateInstance, resetSessionExpiredFlag, SetHeader} from './config'
import {TimezoneConverter} from './util'
import usersAPI from './users'
import {history} from './analystic'
import _ from 'lodash'
import moment from 'moment'
import {session, store} from '@/api/store'

const accessAPI = CreateInstance('access')
const authAPI = CreateInstance('auth')
const FileUploadAPI = CreateInstance('file_upload')
var authenticated = false
var _user = null

const auth = (token) => {
  if (token) return (authenticated = true)
  if (authenticated) {
    store.set('user', store.get('user'), new Date().getTime() + 10800000)
  }
  return authenticated
}

const logout = async () => {
  // 보존할 데이터 백업 (로그아웃 후에도 유지되어야 하는 설정값들)
  const preservedData = {
    remember: store.get('remember'),
    viewMode: store.get('viewMode'),
    notice_skip: store.get('notice_skip'),
    lang: store.get('lang'),
    LMM_MOBILE_EXIST_AUTH: store.get('LMM_MOBILE_EXIST_AUTH'),
    LMM_MOBILE_APPLICATION: store.get('LMM_MOBILE_APPLICATION'),
    popup_skip: store.get('popup_skip'),
  }

  // 모든 데이터 완전 삭제 (메모리 + IndexedDB)
  await store.reset()

  // 보존할 데이터만 다시 저장
  Object.entries(preservedData).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      store.set(key, value)
    }
  })

  // 보존할 데이터를 IndexedDB에 강제 저장
  await store.flush()

  // 세션 데이터 완전 삭제
  session.remove('token')
  session.remove('refresh_token')
  sessionStorage.clear()

  // 인증 상태 해제
  authenticated = false

  return authenticated
}

const user = (value, p, noSync) => {
  if (typeof value === 'string') {
    if (noSync) {
      _user[value] = p
      store.set('user', _user)
      return _user
    }
    let params = {}
    params[value] = p
    return usersAPI.put('0', params)
      .then(resp => {
        _user[value] = p
        store.set('user', _user)
      })
  } else if (typeof value === 'object') {
    const tz = TimezoneConverter('value', value.time_zone_id)
    AppState.Info.timezoneOffset = tz.offset + ' minutes'
    AppState.Info.timezone = tz.name
    _user = value
    store.set('user', _user)
    return _user
  }
  return _user
}

const setPermission = (u, doNotUpdate) => {
  let perm = {}
  if (u.type === 'Manager') {
    perm = {
      isAdmin: true,
      deviceMonitor: true,
      modifyInformation: true,
      useFunction: true,
      viewReport: true,
      CSRemoteControl: true,
      CSFileManager: true,
      CSDeviceManagement: true,
      CSRemoteView: true,
      CSUpdate: true,
      CSThumbnailView: true,
      CSRestart: true
    }
  } else {
    perm.isAdmin = false
    perm.deviceMonitor = true
    perm.modifyInformation = false
    perm.useFunction = false
    perm.viewReport = false
    const authdata = _.map((u.auth_val + '').split(','), v => parseInt(v, 10))
    _.each(authdata, v => {
      if (v === 1) return (perm.deviceMonitor = true)
      if (v === 2) return (perm.modifyInformation = true)
      if (v === 4) return (perm.useFunction = true)
      if (v === 8) return (perm.viewReport = true)
    })
    perm.CSRemoteControl = Boolean(u.auth_remotecontrol)
    perm.CSDeviceManagement = Boolean(u.auth_devicemanagement)
    perm.CSFileManager = Boolean(u.auth_filemanager)
    perm.CSRemoteView = Boolean(u.auth_remoteview)
    perm.CSUpdate = Boolean(u.auth_update)
    perm.CSThumbnailView = Boolean(u.auth_thumbnailview)
    perm.CSRestart = Boolean(u.auth_restart)
  }

  if (!doNotUpdate) {
    AppState.perm = perm
  }

  // if (u.use_approval_function === 1 && u.use_approval) {
  //   AppState.perm.isApprover = true
  // }
  // if (u.member_type_id === 6) {
  //   AppState.perm.isSubManager = true
  // }
  if (u.use_approval_function === 1) {
    AppState.perm.isApprover = true
    if (u.member_type_id === 6) AppState.perm.isSubManager = true
  }
  return perm
}

const calcLicense = (payment) => {
  if (!payment || !payment.length) return null
  var today = new Date().getTime()
  var license = []
  var expireWarnings = []
  license = _.clone(payment.filter(v => !v.pay_lisence_ref))
  var lastest, lastestString
  for (var i = 0; i < license.length; i++) {
    var pk = license[i].pay_pk
    // [임시] 백엔드 UTC naive를 정확히 UTC epoch로 파싱.
    // new Date(naive)는 클라 OS 로컬로 해석해 9h 어긋난 epoch를 만들어
    // 만료 판정이 실제 만료보다 9h 일찍 true가 되던 버그를 차단.
    // (license.vue의 asUtc 헬퍼와 동일 의도. 공용 필터 도입 시 정리 예정)
    var expire = moment.utc(license[i].pay_expire).valueOf()
    var type, payDevVol
    var linked = payment.filter(v => v.pay_lisence_ref === pk)
    if (linked.length) {
      for (var n = 0; n < linked.length; n++) {
        type = linked[n].pay_type
        payDevVol = linked[n].pay_dev_vol
        var tmp = moment.utc(linked[n].pay_expire).valueOf()
        if (expire < tmp) {
          license[i].pay_expire = linked[n].pay_expire
          expire = tmp
        }
      }
      license[i].linked = linked

      if (license[i].pay_type === 'Free') {
        license[i].pay_type = type
        license[i].pay_dev_vol = payDevVol
      }
    }
    if (!lastest || lastest < expire) {
      lastest = expire
      lastestString = license[i].pay_expire
    }
    license[i].expireTimeStamp = expire
    license[i].isExpired = today > expire
    license[i].expireWarning = today > expire - 604800000
    if (license[i].expireWarning && !license[i].isExpired) expireWarnings.push(license[i])
  }
  
  // 사장님 요청사항. 라이선스에 Basic 과 Corporate 타입이 둘 다 있으면, 라이선스 추가 시 제품 유형을 선택할 수 있도록 수정
  const licenseTypes = new Set()
  
  license.forEach(i => {
    licenseTypes.add(i.pay_type)
  })
  
  if (licenseTypes.has('Basic') && licenseTypes.has('Corporate')) {
    AppState.license = 'All'
  } else if (licenseTypes.has('Basic')) {
    AppState.license = 'Basic'
  } else if (licenseTypes.has('Corporate')) {
    AppState.license = 'Corporate'
  } else if (licenseTypes.size === 1 && licenseTypes.has('Free')) {
    AppState.license = 'All'
  } else {
    AppState.license = 'Unknown';
  }
  
  AppState.isCorporate = AppState.license !== 'Basic'
  return {
    total: {
      count: license.length,
      primaryProdType: AppState.license,
      lastestExpireDate: lastest,
      expireWarnings: expireWarnings,
      lastestExpireDateString: lastestString,
      vol: license
        .filter(v => !v.isExpired)
        .reduce((sum, item) => sum + item.pay_dev_vol, 0)
    },
    list: license
  }
}

const getOSId = (name) => {
  var osNames = [
    /Windows/i,
    /Ubuntu|Linux/i,
    /Mac/i,
    /Android/i,
    /IOS/i
  ]
  for (var i = 0; i < osNames.length; i++) {
    if (osNames[i].test(name)) {
      return i + 1
    }
  }
  return 0
}

const getDateFmt = (fmt) => {
  const fmts = [
    'YYYY/MM/DD',
    'MM/DD/YYYY',
    'DD/MM/YYYY'
  ]
  return fmts[fmt - 0]
}

const setDateFmt = (fmtId, fmtValue) => {
  _user.date_fmt_id = fmtId
  _user.dateFmt = fmtValue || getDateFmt(fmtId)
  store.set('user', _user, new Date().getTime() + 10800000)
  return {id: fmtId, value: _user.dateFmt}
}

const getUserData = (token, cb, skipHistoryFlag) => {
  if (token) { SetHeader('token', token) }
  usersAPI.get('0')
    .then(resp => {
      const {objects} = resp.data
      var userData = _.assign(objects,
        {license: calcLicense(objects.pay)},
        {permission: setPermission(objects)},
        {dateFmt: getDateFmt(objects.date_fmt_id)}
      )
      const tz = TimezoneConverter('value', userData.time_zone_id)
      AppState.Info.timezone = tz.name
      AppState.Info.timezoneOffset = tz.offset + ' minutes'
      var profile = userData.mgrid.replace(/[@.]/g, '_')
      userData.profile = profile
      store.set('user', userData, new Date().getTime() + 10800000)
      _user = userData
      authenticated = true

      if (!skipHistoryFlag && token) {
        const ua = parser()
        store.set('ua', ua)
        let params = {
          browser: `${ua.browser.name} v-${ua.browser.major}`,
          dev_os_id: getOSId(ua.os.name),
          type_id: 1 // TYPE login
        }
        history.post('access', params)
      }

      return cb(null, userData)
    })
    .catch(err => {
      Logger.error(err)
      return cb(err)
    })
}

// 로그인 함수, 다른 계정으로 로그인 시 기존 데이터를 완전히 삭제
const login = (authdata, cb) => {
  accessAPI.post('', authdata)
    .then(async resp => {
      const {objects, status} = resp.data
      if (objects.user_type === 7) throw new Error('UserTypeIs7');
      if (status !== 200) return cb(resp.data)
      if (objects.isLogin !== 'Success') return cb(resp.data)

      // 토큰 즉시 저장 (후속 API 호출에서 사용할 수 있도록)
      session.set('token', objects.token)
      session.set('refresh_token', objects.refresh_token)
      SetHeader('token', objects.token)

      // 세션 만료 플래그 리셋 (이전 세션 만료 상태 초기화)
      resetSessionExpiredFlag()

      // 다른 계정인지 확인 (3STEP은 mail 필드가 없으므로 건너뜀)
      const stored = store.get('auth')
      if (authdata.mail && stored && stored.mgrid !== authdata.mail) {
        // 다른 계정! 기존 데이터 백업 후 완전 삭제
        const preservedData = {
          remember: store.get('remember'),
          viewMode: store.get('viewMode'),
          notice_skip: store.get('notice_skip'),
          lang: store.get('lang'),
          LMM_MOBILE_EXIST_AUTH: store.get('LMM_MOBILE_EXIST_AUTH'),
          LMM_MOBILE_APPLICATION: store.get('LMM_MOBILE_APPLICATION'),
          popup_skip: store.get('popup_skip'),
        }
        
        // IndexedDB까지 완전히 삭제
        await store.reset()
        
        // 보존할 데이터만 복원
        Object.entries(preservedData).forEach(([key, value]) => {
          if (value !== null && value !== undefined) {
            store.set(key, value)
          }
        })
        
        // 보존할 데이터를 IndexedDB에 강제 저장
        await store.flush()
      }
      
      // 로그인 정보 저장
      store.set('auth', objects)
      getUserData(objects.token, cb)
    })
    .catch(err => {
      if (err.message === 'UserTypeIs7') {
        alert('파트너 아이디로 로그인 할 수 없습니다.')
      } else {
        Logger.log(err);
      }
    })
}

const requestEmail = (params) => {
  params.type = 'resend'
  return authAPI.post('', params)
    .then(resp => resp.data.objects)
}

const checkAuth = (key) => {
  let params = { key, type: 'auth' }
  return authAPI.post('', params)
    .then(resp => resp.data.objects)
}

export default accessAPI
export { auth, user, login, logout, accessAPI, SetHeader, requestEmail, checkAuth, getUserData, FileUploadAPI, setDateFmt, setPermission, calcLicense }
